const MindmapManage = () => import('@/views/main/promotion/mindmapManage/MindmapManage.vue')
export default {
  path: '/main/promotion/mindmapManage',
  name: 'mindmapManage',
  component: MindmapManage,
  children: []
}
